// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"GroupSummary_radioGroup__1jKNR"};